// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"7ec2ab19","359":"b77c7072","529":"4cb407a4"}[chunkId] + ".chunk.js";
};